import type { EpicProgressBeaconId, EpicProgressSettings } from '../types/epic-progress';

export const EPIC_PROGRESS_BEACON_ID: EpicProgressBeaconId = 'epic-progress';

export const EPIC_PROGRESS_SETTINGS_DEFAULTS: EpicProgressSettings = {
	hidden: false,
};
